import React from 'react';

const LoveAnimation: React.FC = () => {
    return (
        <div className="relative w-full h-[500px]">
            <iframe
                src="/love/love.html"
                className="w-full h-full border-0"
                title="Love Animation"
                style={{
                    width: '100%',
                    height: '100%',
                    display: 'block'
                }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            />
        </div>
    );
};

export default LoveAnimation; 